var map = {
	"./upload-add.svg": "b7ed",
	"./upload-disabled.svg": "310c",
	"./upload-doc.svg": "6668",
	"./upload-error-alt.svg": "8167",
	"./upload-error.svg": "d6be",
	"./upload-file.svg": "4ccc",
	"./upload-loading.svg": "0a23",
	"./upload-outdated.svg": "2ca6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e799";